import RMSTransactionContainer from "./RMSTransactionsContainer";
import RMSTransactionStore from "./RMSTransactionsStore";

export default RMSTransactionStore(RMSTransactionContainer)